import { createGeneralSlice, GeneralSliceType } from 'store/slices/createGeneralSlice';
import { createPageLoadingStateSlice, PageLoadingStateSlice } from 'store/slices/createPageLoadingStateSlice';
import { PortalSlice } from 'store/slices/createPortalSlice';
import { createPortalSlice } from 'store/slices/createPortalSlice';
import { createSelectPickupPointSlice, SelectPickupPointSlice } from 'store/slices/createSelectPickupPointSlice';
import { createSeoCategorySlice, SeoCategorySlice } from 'store/slices/createSeoCategorySlice';
import { create } from 'zustand';

type SessionStore = GeneralSliceType & SelectPickupPointSlice & SeoCategorySlice & PageLoadingStateSlice & PortalSlice;

export const useSessionStore = create<SessionStore>()((...store) => ({
    ...createGeneralSlice(...store),
    ...createPageLoadingStateSlice(...store),
    ...createSelectPickupPointSlice(...store),
    ...createSeoCategorySlice(...store),
    ...createPortalSlice(...store),
}));
